// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"0c2f7ac7","223":"e7928214","481":"a74ece0b","567":"45faa2dc","823":"118d50a6","969":"72dfb0d7"}[chunkId] + ".chunk.js";
};